import React from 'react';

import Navbar from '../../components/Navbar';
import Main from '../../components/Main';
import Section from '../../components/Section';
import Card from '../../components/Card';
import Question from '../../components/Question';
import Blog from '../../components/Blog';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';
import Space from '../../components/Space';

function Home() {
    return (
        <>
            <Navbar />
            <Main/>
            <Section />
            <Card/>
            <Question />
            <Blog />
            <Contact/>
            <Footer />
            <Space />
        </>
    )
}

export default Home;